import React from "react";
import { Input, Pagination } from "antd";
import useLang from "../hooks/useLang";

interface PaginationProps {
	current: any;
	pageSize: number;
	total: number;
	startOrderIndex: any;
	endOrderIndex: number;
	onChange: (page: number, pageSize: number) => void;
	onShowSizeChange?: (current: number, size: number) => void;
	showText?: boolean;
}

const PaginationTable: React.FC<PaginationProps> = ({
	current,
	pageSize,
	total,
	startOrderIndex,
	endOrderIndex,
	onChange,
	onShowSizeChange,
	showText = true,
}) => {
	const { strings } = useLang("pagination");
	const pageSizeOptions = ["20", "50", "100", "150", "200", "500"];
	return (
		<div className="order-info">
			<Pagination
				current={current}
				pageSize={pageSize}
				total={total}
				showSizeChanger
				pageSizeOptions={pageSizeOptions}
				onChange={onChange}
				onShowSizeChange={onShowSizeChange}
				// showQuickJumper
			/>
			<div className="ordersLength">
				<Input value={endOrderIndex} className="w-12" />
				{showText ? (
					<p>
						{strings?.showing} {startOrderIndex} - {endOrderIndex}{" "}
						{strings?.from} {total}
						{/* {strings?.orders} */}
					</p>
				) : (
					<p>
						{startOrderIndex} - {endOrderIndex} {strings?.from}{" "}
						{total}
						{/* {strings?.orders} */}
					</p>
				)}
			</div>
		</div>
	);
};

export default PaginationTable;
